// Angular
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

// Afidium
import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { Yii } from 'libraries/interfaces/Yii';
import { IConfigSharedHotel } from 'libraries/hotel/models/config-shared-hotel';
import { ICost } from 'libraries/service/resources/model/search/IBooking';
import { IPenalty } from 'libraries/service/resources/hotel/IResourceHotel';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Keyword } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { CancellationPipesService } from "./pipes/cancellation-pipes.service";
import { ICancellationKeyword } from "./cancellation-conditions.interface";

//lib
import { faBan, IconDefinition, faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";



export enum ECancellationPerimeter {
    room = 'room',
    hotel = 'hotel'
}

export interface IDisplayCancellationCondition {
    dateLastCancellationWithoutPenalty: string;
    penalty?: IPenalty | IPenalty[];
    price?: ICost;
}

/**
 * Warning : this component have many display combination
 * test it with scenarii from https://redmine.afidium.com/issues/26613
 */
@Component({
    selector: 'cancellation-conditions',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ul class="cancellation">
            <li *ngIf="!hasPenalty && !dateLastCancellationWithoutPenalty">
                <span *ngIf="!dateLastCancellationWithoutPenalty">
                    <fa-icon [icon]="iconBan" class="not-available penalty-icon"></fa-icon>
                    <span *ngIf="!(penalty | hasKeyword:keyword); else noDateAndKeyword">{{ wording.cancelDateWithoutFeesNotAvailable }}</span>
                    <ng-template #noDateAndKeyword>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.nonRefundable)">{{ wording.nonRefundable }}</span>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.refundable)">{{ wording.cancellationFeesArePossible }}</span>
                    </ng-template>
                </span>
            </li>

            <li *ngIf="dateLastCancellationWithoutPenalty && hasPenalty  && !(penalty | areFreeOrFuture) && !(dateLastCancellationWithoutPenalty | isFuture)">
                <span (click)="showPenaltiesItem = !showPenaltiesItem"
                      [class.collapser]="hasArrayPenalties">
                    <fa-icon [icon]="iconBan" class=" has-penalty penalty-icon refundable "></fa-icon>
                    <ng-container *ngIf="penaltiesInFuture && penaltiesInFuture[0] && penaltiesInFuture[0].unitAmount; else noFee">
                        <span>{{ wording.cancellationFeesFrom }}</span>
                        <strong [innerHTML]="penaltiesInFuture[0].unitAmount | priceRealAmount: penaltiesInFuture[0].currency"></strong>
                    </ng-container>
                    <ng-template #noFee>
                        <span>{{ wording.cancellationFees }}</span>
                    </ng-template>
                    <fa-icon *ngIf="hasPenaltyInFuture"
                            [icon]="showPenaltiesItem ? iconAngleUp : iconAngleDown"
                            class="collapser-icon">
                    </fa-icon>
                </span>
            </li>

            <li *ngIf="dateLastCancellationWithoutPenalty && (!hasPenalty || (penalty | areFreeOrFuture))">
                <span *ngIf="dateLastCancellationWithoutPenalty | isFuture"
                      (click)="showPenaltiesItem = !showPenaltiesItem"
                      [class.collapser]="hasArrayPenalties">
                    <fa-icon [icon]="iconBan" class="has-no-penalty penalty-icon "></fa-icon>
                    <span></span>
                    <span *ngIf="!(penalty | hasKeyword:keyword); else futureAndKeyword">{{ dateLastCancellationWithoutPenalty | generateDateWithoutPenalty }} </span>
                    <ng-template #futureAndKeyword>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.nonRefundable)">{{ wording.nonRefundable }}</span>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.refundable)">{{ dateLastCancellationWithoutPenalty | generateDateWithoutPenalty }}</span>
                    </ng-template>
                    <fa-icon *ngIf="hasPenaltyInFuture"
                            [icon]="showPenaltiesItem ? iconAngleUp : iconAngleDown"
                            class="collapser-icon">
                    </fa-icon>
                </span>

                <span *ngIf="!(dateLastCancellationWithoutPenalty | isFuture)"
                      (click)="showPenaltiesItem = !showPenaltiesItem"
                      [class.collapser]="hasArrayPenalties">
                   <fa-icon [icon]="iconBan"
                            [class.refundable]="(penalty | isEqualKeyword: keyword: keywordXCode.refundable) || (penalty && !(penalty | hasKeyword:keyword))"
                            class="has-penalty penalty-icon"></fa-icon>
                    <span *ngIf="!penalty && !keyword">{{ wording.cancellationFeesArePossible }}</span>
                    <span *ngIf="penalty && !(penalty | hasKeyword:keyword); else pastAndKeyword">{{ wording.cancellationFeesArePossible }}</span>
                    <ng-template #pastAndKeyword>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.nonRefundable)">{{ wording.nonRefundable }}</span>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.refundable)">{{ wording.cancellationFees }}</span>
                    </ng-template>
                    <fa-icon *ngIf="hasPenaltyInFuture"
                            [icon]="showPenaltiesItem ? iconAngleUp : iconAngleDown">
                    </fa-icon>
                </span>
            </li>

            <li *ngIf="hasPenalty && !hasArrayPenalties && (uniquePenalty | isFreePenalty)">
                <span *ngIf="uniquePenalty.validity?.end | isFuture">
                    <fa-icon [icon]="iconBan" class="has-penalty penalty-icon"></fa-icon>
                    <span *ngIf="!(penalty | hasKeyword:keyword); else uniqueFutureAndKeyword">{{ uniquePenalty.validity.end | generateDateWithoutPenalty }}</span>
                    <ng-template #uniqueFutureAndKeyword>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.nonRefundable)">{{ wording.nonRefundable }}</span>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.refundable)">{{ uniquePenalty.validity.end | generateDateWithoutPenalty }}</span>
                    </ng-template>
                </span>

                <span *ngIf="!(uniquePenalty.validity?.end | isFuture)">
                    <fa-icon [icon]="iconBan" class="has-penalty penalty-icon"></fa-icon>
                    <span *ngIf="!(penalty | hasKeyword:keyword); else uniquePastAndKeyword">{{ wording.cancelDateWithoutFeesNotAvailable }}</span>
                    <ng-template #uniquePastAndKeyword>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.nonRefundable)">{{ wording.nonRefundable }}</span>
                        <span *ngIf="(penalty | isEqualKeyword: keyword: keywordXCode.refundable)">{{ wording.cancellationFeesArePossible }}</span>
                    </ng-template>
                </span>
            </li>

            <ng-container *ngIf="hasPenalty">
                <li *ngIf="!hasArrayPenalties && !(uniquePenalty | isSameAsDateLastCancellationWithoutPenalty: dateLastCancellationWithoutPenalty) && uniquePenalty.validity">
                    <penalty [penalty]="uniquePenalty"
                             [previousPenalty]="previousPenalty"
                             [basePrice]="price"
                             [configSharedHotel]="configSharedHotel"
                             [currency]="currency"></penalty>
                </li>
                <ng-container *ngIf="hasArrayPenalties">
                    <ng-container *ngFor="let penaltyItem of penaltiesInFuture">
                        <li *ngIf="!dateLastCancellationWithoutPenalty">
                            <span (click)="showPenaltiesItem = !showPenaltiesItem" class="collapser">
                                <fa-icon [icon]="iconBan" class=" has-penalty penalty-icon "></fa-icon>
                                {{wording.cancellationFees}}
                                <fa-icon *ngIf="hasPenaltyInFuture"
                                        [icon]="showPenaltiesItem ? iconAngleUp : iconAngleDown"
                                        class="collapser-icon">
                                </fa-icon>
                            </span>
                        </li>
                        <li *ngIf="showPenaltiesItem">
                            <penalty [penalty]="penaltyItem"
                                     [basePrice]="price"
                                     [configSharedHotel]="configSharedHotel"
                                     [currency]="currency"
                                     [hasIcon]="false"></penalty>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ul>
    `,
    styleUrls: ["cancellation-conditions.component.scss"],
})
export class CancellationConditionsComponent implements OnChanges {

    @Input()
    public keyword: ICancellationKeyword[];

    @Input()
    public perimeter: ECancellationPerimeter;

    public keywordXCode: typeof Keyword = Keyword;

    @Input()
    public dateLastCancellationWithoutPenalty: string;

    @Input()
    public penalty: IPenalty | IPenalty[];

    @Input()
    public price: ICost;

    @Input()
    public previousPenalty: IPenalty;

    @Input()
    public currency: ICurrency;

    @Input()
    public configSharedHotel: IConfigSharedHotel;

    public uniquePenalty: IPenalty;
    public penalties: IPenalty[];
    public penaltiesInFuture: IPenalty[];

    public iconBan: IconDefinition = faBan;

    public iconAngleUp: IconDefinition = faAngleUp;

    public iconAngleDown: IconDefinition = faAngleDown;

    public showPenaltiesItem: boolean = false;

    public readonly wording: ILabels = {
        cancelDateWithoutFeesNotAvailable: Yii.t('wui-shared-js', "Conditions d'annulation indisponibles"),
        cancellationFeesArePossible: Yii.t('wui-shared-js', "Annulation avec frais (non disponibles à ce stade)"),
        cancellationFees: Yii.t('wui-shared-js', "Annulation avec frais"),
        nonRefundable: Yii.t('wui-shared-js', "Non remboursable"),
        cancellationFeesFrom: Yii.t('wui-shared-js', "Frais d'annulation à partir de "),
    };

    public hasPenalty: boolean;
    public hasPenaltyInFuture: boolean;
    public hasArrayPenalties: boolean;

    constructor(
        private readonly cancellationPipesService: CancellationPipesService) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.penalty && changes.penalty.currentValue) {
            this.hasPenalty = this.penalty && (!Array.isArray(this.penalty) || this.penalty.length > 0);
            this.hasArrayPenalties = this.hasPenalty && Array.isArray(this.penalty);

            this.uniquePenalty = !Array.isArray(this.penalty)
                ? this.penalty
                : undefined;
            this.penalties = Array.isArray(this.penalty)
                ? this.penalty
                : undefined;

            this.penaltiesInFuture = this.penalties ?
                this.penalties
                    .filter((penaltyItem: IPenalty) => Boolean(penaltyItem.validity && this.cancellationPipesService.isFuture(penaltyItem.validity.end)))
                    .filter((penaltyItem: IPenalty) => penaltyItem.validity.end !== this.dateLastCancellationWithoutPenalty) :
                undefined;
            this.hasPenaltyInFuture = Boolean(this.penaltiesInFuture && this.penaltiesInFuture.length > 0);

        }
    }

}
